import React, { useState } from "react";
import Banner from "../../images/home/temp_banner.png";
const DaiumCareBanner = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="daium-banner-wrapper">
      <style>{`
        .daium-banner-wrapper {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
          position: fixed;
          right: 80px;
          top: 48%;
          transform: translateY(-50%);
          z-index: 40;
          padding: 0;
          display: none;
        }
        
        @media (min-width: 1536px) {
          .daium-banner-wrapper {
            display: block;
          }
        }
        
        .care-banner {
          width: 160px;
          height: 550px;
          position: relative;
          background: linear-gradient(135deg, #FFB88C 0%, #FFA07A 50%, #FF8A65 100%);
          border-radius: 20px;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 10px 30px rgba(255, 160, 122, 0.3);
        }
        
        .care-banner:hover {
          transform: translateX(5px);
          box-shadow: 0 15px 40px rgba(255, 160, 122, 0.4);
        }
        
        /* 부드러운 배경 패턴 */
        .bg-pattern {
          position: absolute;
          width: 100%;
          height: 100%;
          opacity: 0.1;
          background-image: 
            radial-gradient(circle at 20% 30%, white 2px, transparent 2px),
            radial-gradient(circle at 80% 70%, white 2px, transparent 2px),
            radial-gradient(circle at 50% 50%, white 2px, transparent 2px);
          background-size: 50px 50px;
        }
        
        /* 하트 애니메이션 */
        .floating-hearts {
          position: absolute;
          width: 100%;
          height: 100%;
          pointer-events: none;
        }
        
        .heart {
          position: absolute;
          color: rgba(255, 255, 255, 0.3);
          animation: floatHeart 6s ease-in-out infinite;
        }
        
        .heart-1 {
          top: 20%;
          left: 20%;
          font-size: 20px;
          animation-delay: 0s;
        }
        
        .heart-2 {
          top: 50%;
          right: 25%;
          font-size: 16px;
          animation-delay: 2s;
        }
        
        .heart-3 {
          bottom: 30%;
          left: 30%;
          font-size: 18px;
          animation-delay: 4s;
        }
        
        @keyframes floatHeart {
          0%, 100% {
            transform: translateY(0) scale(1);
            opacity: 0.3;
          }
          50% {
            transform: translateY(-15px) scale(1.1);
            opacity: 0.6;
          }
        }
        
        /* 메인 콘텐츠 */
        .content {
          position: relative;
          z-index: 10;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 25px 15px;
          color: white;
        }
        
        /* 이미지 섹션 */
        .image-section {
          width: 110px;
          height: 110px;
          margin-bottom: 20px;
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 3px solid rgba(255, 255, 255, 0.3);
          transition: all 0.3s ease;
        }
        
        .care-banner:hover .image-section {
          transform: scale(1.05);
          border-color: rgba(255, 255, 255, 0.5);
        }
        
        .placeholder-image {
          font-size: 48px;
          opacity: 0.8;
        }
        
        /* 실제 이미지를 넣을 때 사용 */
        .actual-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
        
        /* 텍스트 섹션 */
        .text-section {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
        }
        
        .main-title {
          font-size: 20px;
          font-weight: 700;
          line-height: 1.3;
          margin-bottom: 15px;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }
        
        .sub-title {
          font-size: 16px;
          font-weight: 500;
          opacity: 0.95;
          margin-bottom: 10px;
        }
        
        .divider {
          width: 40px;
          height: 2px;
          background: rgba(255, 255, 255, 0.5);
          margin: 15px 0;
          border-radius: 1px;
        }
        
        .brand-name {
          font-size: 24px;
          font-weight: 800;
          margin-bottom: 20px;
          letter-spacing: -0.5px;
        }
        
        /* CTA 버튼 */
        .cta-button {
          width: 100%;
          padding: 12px 16px;
          background: white;
          color: #FF8A65;
          border: none;
          border-radius: 25px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          text-decoration: none;
          display: block;
          text-align: center;
        }
        
        .cta-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }
        
        /* 장식 요소 */
        .decoration-circle {
          position: absolute;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          pointer-events: none;
        }
        
        .circle-1 {
          width: 80px;
          height: 80px;
          top: -40px;
          right: -40px;
        }
        
        .circle-2 {
          width: 60px;
          height: 60px;
          bottom: -30px;
          left: -30px;
        }
        
        /* 반짝임 효과 */
        .sparkle-effect {
          position: absolute;
          width: 100%;
          height: 100%;
          pointer-events: none;
        }
        
        .sparkle {
          position: absolute;
          width: 4px;
          height: 4px;
          background: white;
          border-radius: 50%;
          opacity: 0;
          animation: twinkle 3s ease-in-out infinite;
        }
        
        .sparkle-1 {
          top: 15%;
          left: 70%;
          animation-delay: 0s;
        }
        
        .sparkle-2 {
          top: 40%;
          left: 20%;
          animation-delay: 1s;
        }
        
        .sparkle-3 {
          top: 70%;
          right: 25%;
          animation-delay: 2s;
        }
        
        @keyframes twinkle {
          0%, 100% {
            opacity: 0;
            transform: scale(0);
          }
          50% {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>

      <div
        className="care-banner"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => (window.location.href = "#")}
      >
        <div className="bg-pattern"></div>

        <div className="floating-hearts">
          <div className="heart heart-1">♥</div>
          <div className="heart heart-2">♥</div>
          <div className="heart heart-3">♥</div>
        </div>

        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>

        <div className="sparkle-effect">
          <div className="sparkle sparkle-1"></div>
          <div className="sparkle sparkle-2"></div>
          <div className="sparkle sparkle-3"></div>
        </div>

        <div className="content">
          <div className="image-section">
            <img src={Banner} className="actual-image" alt="daium-care-banner" />
          </div>

          <div className="text-section">
            <h2 className="main-title">
              산모신생아
              <br />
              건강관리사
              <br />
              파견
            </h2>

            <div className="divider"></div>

            <div className="sub-title">
              믿을 수 있는
              <br />
              전문 케어
            </div>

            <div className="brand-name">다이음</div>
          </div>

          <button onClick={() => window.open("https://daiumhomepage.dplanit.co.kr/", "_blank")} className="cta-button">
            바로가기
          </button>
        </div>
      </div>
    </div>
  );
};

export default DaiumCareBanner;
